import Vue from 'vue'
import Vuetify from 'vuetify'
import VueRouter from 'vue-router'
import VueAxios from 'vue-axios'
import axios from 'axios'
import router from './router'
import App from './App.vue'
import moment from 'moment'
import { i18n } from './locales/i18n-setup'
import VueMomentJS from 'vue-momentjs'
import store from './store/store'
import nsTranslations from './mixins/nsTranslations'
import validationRules from './mixins/validationRules'
import notificationHandler from './mixins/notificationHandler'
import './utils/referralToSessionStorage'

import Raven from 'raven-js'
import RavenVue from 'raven-js/plugins/vue'

import { abilitiesPlugin } from '@casl/vue'
import { ability } from './permissions/rules'

import AppLayout from './components/layouts/AppLayout'
import WebsiteLayout from './components/layouts/WebsiteLayout'
import './registerServiceWorker'

import FrontendComponents from '@elsazeit/frontend-components'
import VeeValidate from 'vee-validate'

Vue.use(Vuetify, {
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    primary: '#1976d2',
    secondary: '#424242',
    accent: '#82b1ff',
    error: '#ff5252',
    info: '#2196f3',
    success: '#4caf50',
    warning: '#fb8c00'
  }
})

Vue.use(VueRouter)
Vue.use(VueAxios, axios)
Vue.use(VueMomentJS, moment)
Vue.use(abilitiesPlugin, ability)
Vue.use(FrontendComponents)
Vue.use(VeeValidate)

if (process.env.node_env === 'production' && process.env.VUE_APP_SENTRY_DSN) {
  Raven
    .config(process.env.VUE_APP_SENTRY_DSN)
    .addPlugin(RavenVue, Vue)
    .install()
  Vue.config.errorHandler = err => Raven.captureException(err)
}

// global components
Vue.component('AppLayout', AppLayout)
Vue.component('WebsiteLayout', WebsiteLayout)

Vue.mixin(nsTranslations)
Vue.mixin(validationRules)
Vue.mixin(notificationHandler)

new Vue(Vue.util.extend({ router, store, i18n }, App)).$mount('#app')
